import React from 'react';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { Form, Select, InputNumber } from 'antd';
import './TimeSpanComponent.scss';

const FormItem = Form.Item;
const messages = defineMessages({
  minutes: {
    id: 'TimeSpan.Minutes',
    defaultMessage: 'Minutes',
  },
  hours: {
    id: 'TimeSpan.Hours',
    defaultMessage: 'Hours',
  },
  days: {
    id: 'TimeSpan.Days',
    defaultMessage: 'Days',
  },
  weeks: {
    id: 'TimeSpan.Weeks',
    defaultMessage: 'Weeks',
  },
  inputDuration: {
    id: 'TimeSpan.Message.InputDuration',
    defaultMessage: 'Please input duration',
  },
  duration: {
    id: 'TimeSpan.Duration',
    defaultMessage: 'Duration',
  },
});

function TimeSpan(props) {
  const { Option } = Select;
  const { getFieldDecorator, timeSlotText, slotDuration, defaultDuration, intl, timeUnitText } = props;
  const durationElement = (
    <Select>
      <Option value="Minutes" key="1">
        <FormattedMessage {...messages.minutes} />
      </Option>
    </Select>
  );

  return (
    <React.Fragment>
      <div className="input-duration">
        <FormItem style={{ marginBottom: 0 }}>
          {getFieldDecorator(timeSlotText, {
            initialValue: slotDuration || defaultDuration,
            rules: [
              {
                required: false,
                message: <FormattedMessage {...messages.inputDuration} />,
              },
            ],
          })(<InputNumber placeholder={intl.formatMessage({ ...messages.duration })} className="input-number" />)}
        </FormItem>
      </div>

      <div className="input-time-unit">
        <FormItem style={{ marginBottom: 0 }}>
          {getFieldDecorator(timeUnitText, {
            valuePropName: 'value',
            initialValue: intl.formatMessage({ ...messages.minutes }),
          })(durationElement)}
        </FormItem>
      </div>
    </React.Fragment>
  );
}

TimeSpan.propTypes = {
  getFieldDecorator: PropTypes.func.isRequired,
  timeSlotText: PropTypes.string.isRequired,
  timeUnitText: PropTypes.string.isRequired,
  slotDuration: PropTypes.number,
  defaultDuration: PropTypes.number.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
};

TimeSpan.defaultProps = {
  slotDuration: 30,
};

export default injectIntl(TimeSpan);
